import { connect, MapStateToProps } from 'react-redux';
import { Props } from './ResetPasswordPage';
import { AppState } from '../../../types/store';

type StateProps = Pick<Props, 'username' | 'passkey' | 'errorCode'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (state: AppState) => {
  return {
    username: state.resetPassword.username,
    passkey: state.resetPassword.passkey,
    errorCode: state.resetPassword.passwordErrorCode,
  };
};

export default connect(mapStateToProps);
